export enum displayMode {
  SHOWN_AS_DEFAULT = 'ShownAsDefault',
  HIDDEN_AS_DEFAULT = 'HiddenAsDefault',
  SHOWN_FORCED = 'ShownForced',
  SHOWN = 'Shown',
  HIDDEN = 'Hidden',
  HIDDEN_FORCED = 'HiddenForced',
}
